import { client as browserClient } from '@api/client';
import type { Client } from '@api/functions';
import type { ReportCreate, ReportReceived } from '@api/types';
import { ReportSource } from '@shared/types/report';

export const getReportReasons = (source: ReportSource, client?: Client) => {
    return (client || browserClient).GET('/report-reason', {
        params: {
            query: {
                source: source,
            },
        },
    });
};

export const createReportContent = (reportCreate: ReportCreate) => {
    return browserClient.POST('/contact-form', { body: reportCreate });
};

export const createReport = (reportCreate: ReportReceived) => {
    return browserClient.POST('/report', { body: reportCreate });
};

